import type { FormSubmission, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { FormSubmissionMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const FormSubmissionMention = Mention.extend<MentionOptions<Stored<FormSubmission>>>({
	name: "formSubmissionMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "form-submission-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["form-submission-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(FormSubmissionMentionComponent)
	},
}).configure({
	suggestion,
})
